module.exports = __webpack_public_path__ + "img/img_sld_big.ba013753.png";